/* eslint-disable import/no-commonjs -- next.config.js requires this file, so it cannot be ESM. */
const TOKEN_ROUTES = ["magiclink", "activate", "forgot-password"];

// The API paths these pages call. Spelled differently from the page routes, so
// redaction has to know both.
const TOKEN_API_PATHS = ["magic_link", "forgotten_password"];

module.exports = { TOKEN_ROUTES, TOKEN_API_PATHS };
